import React from "react";
import { connect } from "react-redux";
import jsPDF from "jspdf"

import "./Request.css"

import initFonts from "../../../../helpers/fonts"
import history from "../../../../history";
import { getRequest, cancelRequest, setAttachment, acceptRequest, rejectRequest } from "../../../../actions/requestActions";
import { resetReport, getReport } from "../../../../actions/workingTimeActions";

import Modal from "../../../CustomViews/Modal";

class Request extends React.Component {
    constructor(props) {
        super(props);

        this.modalMessage = React.createRef();

        this.state = {
            modal: false,
            modalType: ""
        };

        this.reportMonth = "none";
    }

    componentDidMount() {
        initFonts();
        this.props.resetReport();
        this.props.getRequest(this.props.match.params.requestID);
    }

    componentDidUpdate() {
        if (this.props.currentRequest.requestID && this.props.currentRequest.requestID === +this.props.match.params.requestID && this.props.currentRequest.absenceID === -1) {
            const forMonth = this.calcForMonth(this.props.currentRequest);
            const currMonth = this.getYearAndMonth(true);
            const prevMonth = this.getYearAndMonth(false);

            if (forMonth.year === currMonth.year && forMonth.month === currMonth.month) {
                if (this.reportMonth === "current") return;
                this.reportMonth = "current";
                this.props.getReport(this.props.currentRequest.userID, this.reportMonth);
            } else if (forMonth.year === prevMonth.year && forMonth.month === prevMonth.month) {
                if (this.reportMonth === "previous") return;
                this.reportMonth = "previous";
                this.props.getReport(this.props.currentRequest.userID, this.reportMonth);
            } else if (this.reportMonth !== "none") {
                this.reportMonth = "none";
            }
        }
    }

    calcForMonth = request => {
        if (!request.requestID || request.absenceID !== -1) return { year: null, month: null };
        const submitDate = new Date(request.submitedOn);
        const startDate = new Date(request.dateFrom);

        if (submitDate.getMonth() + 1 === request.forMonth) return { year: submitDate.getFullYear(), month: submitDate.getMonth() + 1 };
        else if (submitDate.getMonth() === request.forMonth) return { year: submitDate.getFullYear(), month: submitDate.getMonth() };
        else if (submitDate.getMonth() === 0 && request.forMonth === 12) return { year: submitDate.getFullYear() - 1, month: request.forMonth };
        if (startDate.getMonth() + 1 === request.forMonth) return { year: startDate.getFullYear(), month: startDate.getMonth() + 1 };
        else if (startDate.getMonth() === request.forMonth) return { year: startDate.getFullYear(), month: startDate.getMonth() };
        else if (startDate.getMonth() === 0 && request.forMonth === 12) return { year: startDate.getFullYear() - 1, month: request.forMonth };
        else return { year: null, month: null };
    };

    getYearAndMonth = current => {
        const date = new Date();

        if (current) return { year: date.getFullYear(), month: date.getMonth() + 1 };
        else if (date.getMonth() > 0) return { year: date.getFullYear(), month: date.getMonth() };
        else return { year: date.getFullYear() - 1, month: 12 };
    };

    formatValue = value => `${value < 0 ? "-" : ""}${Math.floor(Math.abs(value))}:${Math.round(60 * (Math.abs(value) % 1)) < 10 ? "0" : ""}${Math.round(60 * (Math.abs(value) % 1))}`;

    shortTime = time => time.substring(0, time.lastIndexOf(":"));
    monthName = month => ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"][month - 1];

    countBusinessDays = (startDate, endDate) => {
        let elapsed, daysBeforeFirstSunday, daysAfterLastSunday;
        const ifThen = function (a, b, c) {
            return a === b ? c : a;
        };
    
        elapsed = endDate - startDate;
        elapsed /= 86400000;
    
        daysBeforeFirstSunday = (7 - startDate.getDay()) % 7;
        daysAfterLastSunday = endDate.getDay();
    
        elapsed -= (daysBeforeFirstSunday + daysAfterLastSunday);
        elapsed = (elapsed / 7) * 5;
        elapsed += ifThen(daysBeforeFirstSunday - 1, -1, 0) + ifThen(daysAfterLastSunday, 6, 5);
    
        return Math.ceil(elapsed);
    };

    onOperationClick = (type) => this.setState({
        modal: true,
        modalType: type
    });

    onOperationApprove = (action) => action(this.props.currentRequest.requestID);

    printDocument = () => {    
        const pdf = new jsPDF("p", "mm", "a4");
        let pageWidth = pdf.internal.pageSize.width || pdf.internal.pageSize.getWidth();
        let yPos = 0;
        pdf.setFont("arial", "normal");
        pdf.setFontSize(14);
        pdf.setFontSize(28);
        yPos += 25; pdf.text(this.props.currentRequest.absenceName, pageWidth / 2, yPos, { align: "center" });
        pdf.setFontSize(14);
        yPos += 10; pdf.text(`Wniosek nr ${this.props.currentRequest.requestID}`, pageWidth / 2, yPos, { align: "center" });
        pdf.setFontSize(11);
        yPos += 20; pdf.text("Wnioskujący:", 20, yPos);
        yPos += 10; pdf.text("Jednostka organizacyjna:", 20, yPos);
        pdf.setFont("arial", "bold");
        pdf.setFontSize(14);
        yPos -= 10; pdf.text(`${this.props.currentRequest.fname} ${this.props.currentRequest.lname}`, 45, yPos);
        pdf.setFontSize(11);
        yPos += 10; pdf.text(this.props.currentRequest.ouName, 66, yPos);
        pdf.setFont("arial", "normal");
        yPos += 20; pdf.text(`W ${this.props.currentRequest.absenceID === -1 ? "godzinach" : "dniach"}:`, 20, yPos);
        yPos += 10; pdf.text(`${this.props.currentRequest.absenceID === -1 ? "Za miesiąc" : "Liczba dni"}:`, 20, yPos);
        pdf.setFont("arial", "bold");
        pdf.setFontSize(14);
        if (this.props.currentRequest.absenceID === -1) {
            yPos -= 10; pdf.text(`od ${this.shortTime(this.props.currentRequest.timeFrom)} do ${this.shortTime(this.props.currentRequest.timeTo)}`, 46, yPos);
            yPos += 10; pdf.text(this.monthName(this.props.currentRequest.forMonth), 42, yPos);
        } else {
            yPos -= 10; pdf.text(`od ${this.props.currentRequest.dateFrom} do ${this.props.currentRequest.dateTo}`, 40, yPos);
            yPos += 10; pdf.text(`${this.countBusinessDays(new Date(this.props.currentRequest.dateFrom), new Date(this.props.currentRequest.dateTo))}`, 41, yPos);
        }
        pdf.setFont("arial", "normal");
        pdf.setFontSize(11);
        yPos += 20; pdf.text("Data złożenia wniosku:", 20, yPos);
        pdf.setFont("arial", "italic");
        pdf.text(this.props.currentRequest.submitedOn, 61, yPos);
        pdf.setFont("arial", "normal");
        yPos += 20; pdf.text("Podpis pracownika:", 20, yPos);
        pdf.text("Akceptacja przełożonego:", 190, yPos, { align: "right" });
        pdf.save(`Wniosek urlopowy nr ${this.props.currentRequest.requestID}`);
    };

    renderModal = () => {
        if (this.state.modal) {
            if (this.state.modalType === "cancel") {
                return (
                    <Modal
                        title="Wycofanie wniosku"
                        content={<p>Czy na pewno chcesz wycofać ten wniosek?</p>}
                        actions={(
                            <React.Fragment>
                                <button onClick={() => history.go(0)} className="ui button">Anuluj</button>
                                <button onClick={() => this.onOperationApprove(this.props.cancelRequest)} className="ui negative button">Wycofaj</button>
                            </React.Fragment>
                        )}
                        onDismiss={() => history.go(0)}
                    />
                );

            } else if (this.state.modalType === "attachment") {
                return (
                    <Modal
                        title="Potwierdzenie dostarczenia załącznika"
                        content={<p>Czy na pewno chcesz potwierdzić dostarczenie załącznika do tego wniosku?</p>}
                        actions={(
                            <React.Fragment>
                                <button onClick={() => history.go(0)} className="ui button">Anuluj</button>
                                <button onClick={() => this.onOperationApprove(this.props.setAttachment)} className="ui primary button">Potwierdź</button>
                            </React.Fragment>
                        )}
                        onDismiss={() => history.go(0)}
                    />
                );

            } else if (this.state.modalType === "accept") {
                return (
                    <Modal
                        title="Akceptacja wniosku"
                        content={<p>Czy na pewno chcesz zaakceptować ten wniosek?</p>}
                        actions={(
                            <React.Fragment>
                                <button onClick={() => history.go(0)} className="ui button">Anuluj</button>
                                <button onClick={() => this.onOperationApprove(this.props.acceptRequest)} className="ui positive button">Akceptuj</button>
                            </React.Fragment>
                        )}
                        onDismiss={() => history.go(0)}
                    />
                );

            } else if (this.state.modalType === "reject") {
                return (
                    <Modal
                        title="Odrzucenie wniosku"
                        content={<p>Czy na pewno chcesz odrucić ten wniosek?</p>}
                        actions={(
                            <React.Fragment>
                                <button onClick={() => history.go(0)} className="ui button">Anuluj</button>
                                <button onClick={() => this.onOperationApprove(this.props.rejectRequest)} className="ui negative button">Odrzuć</button>
                            </React.Fragment>
                        )}
                        onDismiss={() => history.go(0)}
                    />
                );
            }
        }
    };

    renderStatus = request => {
        if (request.canceled === 1) return (<span><b><span className="red content">Wycofany</span></b> dnia <b>{request.canceledOn}</b></span>);
        else if (request.entered === -1) return (<span><b><span className="red content">Odrzucony przez kadry</span></b> dnia <b>{request.enteredOn}</b></span>);
        else if (request.entered === 1) return (<span><b><span className="green content">Wpisany w systemie</span></b> dnia <b>{request.enteredOn}</b></span>);
        else if (request.accepted === 1) return (<span><b><span className="green content">Zaakceptowany przez przełożonych</span></b></span>);
        else if (request.accepted === -1) return (<span><b><span className="red content">Odrzucony</span></b></span>);
        else return (<span><b><span className="orange content">Oczekuje na akceptację przełożonych</span></b></span>);
    };

    renderConfirmations = () => this.props.currentRequest.confirmations.map((confirmation, index) => {
        return (
            <div className="ui segment" key={index}>
                <div className="ui grid">
                    <div className="four wide column">
                        <div className="content">{confirmation.ouName}:</div>
                    </div>
                    <div className={`${confirmation.fname ? "four" : "twelve"} wide column`}>
                        <div className="content">
                            <b>{confirmation.required ? (
                                confirmation.fname ? `${confirmation.lname} ${confirmation.fname}` : (
                                    <span className="orange content">Oczekuje na akceptację</span>
                                )
                            ) : <span className="orange content">Wniosek nie wymagał zatwierdzenia na tym etapie</span>}</b>
                        </div>
                    </div>
                    {confirmation.fname ? (
                        <div className="eight wide column">
                            <div className="content">{confirmation.accepted === 1 ? (
                                <span><b><span className="green content">Zaakceptowany</span></b> dnia <b>{confirmation.acceptedOn}</b></span>
                            ) : (
                                <span><b><span className="red content">Odrzucony</span></b> dnia <b>{confirmation.acceptedOn}</b></span>
                            )}</div>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    });

    render() {
        let message = null;
        if (this.props.currentRequest.requestID && this.props.currentRequest.absenceID === -1) {
            const forMonth = this.calcForMonth(this.props.currentRequest);
            const currMonth = this.getYearAndMonth(true);
            const prevMonth = this.getYearAndMonth(false);

            if (((forMonth.year === currMonth.year && forMonth.month === currMonth.month) ||
                (forMonth.year === prevMonth.year && forMonth.month === prevMonth.month))
                && this.props.report.reportID) {
                message = (<div className="ui warning message">Liczba nadgodzin w wybranym miesiącu: {this.formatValue(this.props.report.availableOvertime)}</div>);
            } else {
                message = (<div className="ui warning message">Liczba nadgodzin w wybranym miesiącu: brak danych</div>);
            }
        }

        return (
            <React.Fragment>
                <div className="request-component ui container">              
                    <div className="ui container">
                        <div className="ui segments" id="capture">
                            <div className="ui segment">
                                <div className="ui grid">
                                    <div className="two columns row">
                                        <div className="column">
                                            <div className="ui header">
                                                <i className="file alternate icon"></i>
                                                Wniosek nr: {this.props.currentRequest.requestID}
                                            </div>
                                        </div>
                                        <div className="right aligned column">
                                            <div className="content">
                                                Przyczyna absencji: <b>{this.props.currentRequest.absenceName}</b>
                                                {this.props.currentRequest.absenceID === 8 ? (
                                                    <React.Fragment>
                                                        <br />
                                                        Powód: <b>{this.props.currentRequest.occasionName}</b>
                                                    </React.Fragment>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ui horizontal segments">
                                <div className="ui segment" style={{ width: "50%" }}>
                                    <div className="ui grid">
                                        <div className="six wide middle aligned column">
                                                <h2 className="ui icon header">
                                                <i className="user circle icon"></i>
                                            </h2>
                                        </div>
                                        <div className="ten wide middle aligned column">
                                            <div className="content">
                                                <b>{this.props.currentRequest.fname}</b><br />
                                                <b>{this.props.currentRequest.lname}</b><br />
                                                {this.props.currentRequest.email}<br />
                                                <span className="placeholder">{this.props.currentRequest.ouName}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ui segment" style={{ width: "50%" }}>
                                    <div className="ui grid">
                                        <div className="row">
                                            <div className="six wide middle aligned column">
                                                    <h2 className="ui icon header">
                                                    <i className="calendar alternate icon"></i>
                                                </h2>
                                            </div>
                                            <div className="ten wide middle aligned column">
                                                <div className="content">
                                                    {this.props.currentRequest.absenceID === -1 ? (
                                                        <React.Fragment>
                                                            W dniu: <b>{this.props.currentRequest.dateFrom}</b><br />
                                                            Od: <b>{this.shortTime(this.props.currentRequest.timeFrom)}</b><br />
                                                            Do: <b>{this.shortTime(this.props.currentRequest.timeTo)}</b><br />
                                                            Za miesiąc: <b>{this.monthName(this.props.currentRequest.forMonth)}</b>
                                                        </React.Fragment>
                                                    ) : (
                                                        <React.Fragment>
                                                            W dniach:<br />
                                                            Od: <b>{this.props.currentRequest.dateFrom}</b><br />
                                                            Do: <b>{this.props.currentRequest.dateTo}</b>
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        {message ? (
                                            <div className="row">
                                                <div className="column">
                                                    {message}
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            <div className="ui segment">
                                <div className="ui grid">
                                    <div className="two columns row">
                                        <div className="column">
                                            {this.props.currentRequest.confirmations.length ? (
                                                <div className="content">Potwierdzenia:</div>
                                            ) : null}
                                        </div>
                                        <div className="right aligned column">
                                            <div className="content">Status: {this.renderStatus(this.props.currentRequest)}</div>
                                        </div>
                                    </div>
                                </div>
                                {this.props.currentRequest.confirmations.length ? (
                                    <div className="ui segments">
                                        {this.renderConfirmations()}
                                    </div>
                                ) : null}
                            </div>
                            <div className="ui segment">
                                <div className="content">Złożony dnia: <b>{this.props.currentRequest.submitedOn}</b></div>
                            </div>
                        </div>
                        {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID && this.props.currentRequest.attachmentRequired && !this.props.currentRequest.attachment ? (
                            <div className="ui tertiary inverted red segment">
                                <div className="ui middle aligned grid">
                                    <div className="twelve wide column">
                                        <div className="content">Ten wniosek wymaga dostarczenia załącznika</div>
                                    </div>
                                    <div className="four wide column">
                                        <div className="content"><button className="ui button" type="button" onClick={() => this.onOperationClick("attachment")}>Potwierdź dostarczenie załącznika</button></div>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        <div className="ui three columns buttons grid">
                            <div className="column">
                                {this.props.currentRequest.actionAllowed || this.props.currentRequest.hrActionAllowed ? (
                                    <React.Fragment>
                                        <button className={`ui positive ${this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID && this.props.currentRequest.hrActionAllowed && !this.props.currentRequest.actionAllowed && this.props.currentRequest.attachmentRequired && !this.props.currentRequest.attachment ? "disabled" : ""} button`} type="button" onClick={() => this.onOperationClick("accept")}>{`${this.props.currentRequest.actionAllowed ? "Akceptuj" : "Zatwierdź w systemie"}`}</button>
                                        <button className="ui negative button" type="button" onClick={() => this.onOperationClick("reject")}>Odrzuć</button>
                                    </React.Fragment>
                                ) : null}
                            </div>
                            <div className="column">
                                <button className="ui primary button" type="button" onClick={this.printDocument}>Pobierz PDF</button>
                            </div>
                            <div className="column">
                                {(this.props.currentRequest.canceled !== 1 && (this.props.currentUser.admin === 1 || (this.props.currentRequest.userID === this.props.currentUser.userID && this.props.currentRequest.accepted !== -1 && this.props.currentRequest.entered === 0))) ? (
                                    <button className="ui negative button" type="button" onClick={() => this.onOperationClick("cancel")}>Wycofaj</button>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderModal()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    currentRequest: state.request.current,
    report: state.workingTime.report
});

export default connect(mapStateToProps, { getRequest, cancelRequest, setAttachment, acceptRequest, rejectRequest, resetReport, getReport })(Request);